import { useCallback } from "react";
import { Box, Button, Text } from "@vinomofo/components";
import styled from "styled-components";
import { navigate } from "gatsby";
import useAuth from "../../hooks/use-auth";

const Container = styled(Text)`
  font-weight: 500;
  align-self: center;
`;

const LoginButton = styled(Button)`
  font-family: ${({ theme }) => theme.fonts.heading};
  background-color: #fbc44e;
  color: #000;
  border: none;
  font-size: 13px;
  border-radius: 35px;
  padding: 11px 20px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  text-align: center;
  text-decoration: none;
  &:hover {
    background-color: #ffa11c;
    text-decoration: none;
  }
  @media ${({ theme }) => theme.mq.max.mobile} {
    background-color: transparent;
    border: 1px solid #fbc44e;
    color: #fbc44e;
    padding: 10px 10px;
    max-width: 100px;
    font-size: 12px;
    &:hover {
      background-color: #fbc44e;
      text-decoration: none;
      color: #000;
    }
  }
`;

const SignUpButton = styled(Button)`
  font-family: ${({ theme }) => theme.fonts.heading};
  background-color: transparent;
  color: #fbc44e;
  border: 1px solid #fbc44e;
  font-size: 13px;
  border-radius: 35px;
  padding: 11px 20px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  text-align: center;
  text-decoration: none;
  margin-left: 10px;
  &:hover {
    background-color: #fbc44e;
    text-decoration: none;
    color: #000;
  }
  @media ${({ theme }) => theme.mq.max.mobile} {
    background-color: transparent;
    border: 1px solid #fbc44e;
    color: #fbc44e;
    padding: 10px 10px;
    max-width: 100px;
    font-size: 12px;
    &:hover {
      background-color: #fbc44e;
      text-decoration: none;
      color: #000;
    }
  }
`;

const DesktopOnly = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: right;
  @media ${({ theme }) => theme.mq.max.mobile} {
    display: none;
  }
`;

const MobileOnly = styled(Box)`
  display: none;
  width: 100%;
  @media ${({ theme }) => theme.mq.max.mobile} {
    display: flex;
    justify-content: right;
    width: 100%;
  }
`;

const LoginSignup = () => {
  const { login, isAuthenticated } = useAuth();

  const handleLogin = useCallback(() => {
    login({ returnTo: "/deals" });
  }, [login]);

  const handleSignUp = useCallback(() => {
    navigate("/deals");
  }, []);

  return (
    <>
      <DesktopOnly>
        <Container
          forwardedAs="div"
          color="white"
          fontFamily={"normal"}
          fontWeight="500"
        >
          {!isAuthenticated ? (
            <Button
              onClick={handleLogin}
              color="white"
              fontFamily={"normal"}
              fontSize={[0, 1]}
              px={20}
              fontWeight="500"
            >
              Login
            </Button>
          ) : (
            <SignUpButton onClick={handleSignUp}>See my Deals!</SignUpButton>
          )}
        </Container>
      </DesktopOnly>
      <MobileOnly>
        {!isAuthenticated ? (
          <LoginButton onClick={handleLogin}>Login</LoginButton>
        ) : (
          <SignUpButton onClick={handleSignUp}>See my Deals!</SignUpButton>
        )}
      </MobileOnly>
    </>
  );
};

export default LoginSignup;
